import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  inputBox: {
    padding: theme.spacing(1),
    border: theme.custom.border.secondary,
    borderRadius: "4px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& .MuiChip-root": {
      margin: theme.spacing(0.5, 0.5),
      height: "26px",
    },
  },
  input: {
    marginRight: theme.spacing(2),
    "& .MuiInputBase-root:before,& .MuiInputBase-root:after": {
      display: "none",
    },
    "& .MuiInputBase-root": {
      margin: 0,
    },
  },
  add: {
    borderRadius: "0",
    borderLeft: theme.custom.border.secondary,
    padding: theme.spacing(0.75, 2.5),
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.custom.linkHover.color,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "20px",
      marginRight: theme.spacing(1),
    },
  },
  empty: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.26),
  },
  list: {
    marginTop: theme.spacing(2),
  },
  img: {
    display: "flex",
    marginRight: theme.spacing(2),
  },
  desc: {
    display: "flex",
    fontSize: "16px",
    letterSpacing: 0,
    lineHeight: "24px",
    color: theme.custom.color.mortar,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 1.5),
    borderBottom: theme.custom.border.secondary,
  },
  listname: {
    fontSize: "14px",
    letterSpacing: "normal",
    lineHeight: "16px",
    fontWeight: "bold",
    color: theme.custom.color.blackRussian,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
    },
  },
  listBtnGrp: {
    display: "flex",
    flexDirection: "row",
  },
  delete: {
    display: "flex",
    color: theme.custom.color.pewter,
    padding: theme.spacing(0.75, 0),
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.custom.linkHover.color,
    },
  },
  alignItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 1.5),
  },
  alignLabel: {
    width: "450px",
  },
  type: {
    color: "#737373",
    fontSize: "14px",
    lineHeight: "18px,",
  },
  paper: {
    padding: theme.spacing(1, 1, 1, 0),
    boxShadow: theme.custom.boxShadow.paper,
    borderRadius: "10px",
    border: "none",
    "& .MuiAutocomplete-listbox": {
      padding: theme.spacing(0, 2),
      maxHeight: "218px",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: theme.custom.color.gainsboro,
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: theme.custom.color.gainsboro,
      },
    },
    "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
      padding: theme.spacing(0.5, 1),
      borderTop: theme.custom.border.listItem,
    },
    "& .MuiAutocomplete-listbox .MuiAutocomplete-option:hover": {
      backgroundColor: "transparent",
    },
    "& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected='true']":
      {
        backgroundColor: "transparent",
      },
    "& .MuiAutocomplete-listbox .MuiAutocomplete-option:first-child": {
      padding: theme.spacing(0.5, 0),
      borderTop: "none",
    },
    "& .MuiAutocomplete-listbox .MuiAutocomplete-option .MuiCheckbox-root": {
      padding: theme.spacing(1, 1, 1, 0),
      color: theme.custom.color.black,
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&.Mui-checked": {
        color: theme.custom.color.summersky,
      },
      "& .MuiSvgIcon-root": {
        fontSize: "19px",
      },
      "& .MuiTouchRipple-root": {
        display: "none",
      },
    },
  },
}));
